<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto">
      <notifications group="error" position="top center" class="mt-1" />
      <notifications group="success" position="top left" class="mt-1" />
      <notifications group="info" position="top left" class="mt-1" />
      <notifications group="warn" position="top left" class="mt-1" />
      <loading v-if="vLoading" />
    </v-col>

    <b-card header-bg-variant="primary" header-text-variant="white">
      <v-row class="p-0">
        <v-col cols="4">
          <date-picker
            placeholder="تاریخ شروع"
            v-model="startDate"
            :editable="true"
          ></date-picker
        ></v-col>
        <v-col cols="4">
          <date-picker
            placeholder="تاریخ پایان"
            v-model="endDate"
            :editable="true"
          ></date-picker
        ></v-col>
        <v-col cols="4">
          <b-btn class="btn btn-dark" @click="getItems()">جستجو</b-btn>
        </v-col>
      </v-row>
      <v-row v-if="items.length">
        <b-table
          responsive
          show-empty
          :items="items"
          :fields="itemFields"
          :current-page="itemCurrentPage"
          :per-page="itemPerPage"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
        >
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ (itemCurrentPage - 1) * itemPerPage + data.index + 1 }}
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(number)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(totalCount)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(description)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn class="url" @click="getDescriptionItems(data.item)">{{
                data.value
              }}</b-btn>
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
        <b-pagination
          v-model="itemCurrentPage"
          :total-rows="items.length"
          :per-page="itemPerPage"
          aria-controls="customers-tabel"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </v-row>
    </b-card>
    <v-dialog
      transition="dialog-bottom-transition"
      scrollable
      v-model="descriptionModal"
      max-width="800px"
    >
      <v-card>
        <v-card-title dark>
          <h4 class="mt-4">
            جزییات سفارش‌های {{ selectedDescription }} از تاریخ
            {{ startDate }} لغایت {{ endDate }}
          </h4>
        </v-card-title>
        <b-table
          responsive
          show-empty
          :items="descriptionItems"
          :fields="descriptionFields"
          :current-page="descriptionCurrentPage"
          :per-page="descriptionPerPage"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :busy="descriptionLoading"
        >
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{
                (descriptionCurrentPage - 1) * descriptionPerPage +
                data.index +
                1
              }}
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(number)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(totalCount)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
        <b-pagination
          v-model="descriptionCurrentPage"
          :total-rows="descriptionItems.length"
          :per-page="descriptionPerPage"
          aria-controls="customers-tabel"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="descriptionModal = false"
          >
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import BarChart from "/src/components/charts/BarExample.vue";
import PieChart from "/src/components/charts/PieExample.vue";
import LineChart from "/src/components/charts/LineExample.vue";

export default {
  components: {
    BarChart,
    PieChart,
    LineChart,
    datePicker: VuePersianDatetimePicker,
  },
  data: function () {
    return {
      vLoading: false,
      guide: false,
      isBusy: false,
      dashboard: {},

      striped: true,
      startDate: moment(new Date())
        .subtract(30, "days")
        .format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).add(7, "d").format("jYYYY/jMM/jDD"),
      items: [],
      itemFields: [
        { key: "index", label: "#" },
        { key: "description", sortable: true, label: "شرح کالا" },
        { key: "number", sortable: true, label: "دفعات سفارش" },
        { key: "totalCount", sortable: true, label: "مجموع حجم سفارش" },
      ],
      descriptionFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح کالا" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", sortable: true, label: "دفعات سفارش" },
        { key: "totalCount", sortable: true, label: "مجموع حجم سفارش" },
      ],
      itemCurrentPage: 1,
      itemPerPage: 10,
      selectedDescription: "",
      descriptionItems: [],
      descriptionModal: false,
      descriptionLoading: false,
      descriptionCurrentPage: 1,
      descriptionPerPage: 5,
    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },

    getItems() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/office/reports/orderItemsCount",
        {
          start: this.startDate + "00:00",
          end: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.items = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.vLoading = false;
        });
    },
    getDescriptionItems(description) {
      this.selectedDescription = description.description;
      this.descriptionCurrentPage = 1;
      this.descriptionModal = true;
      this.descriptionLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/office/reports/orderItemByDescriptionCount",
        {
          start: this.startDate + "00:00",
          end: this.endDate + "23:59",
          description: this.selectedDescription,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.descriptionItems = res.data;
            this.descriptionLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.descriptionModal = false;
            this.descriptionLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.vLoading = false;
          this.descriptionModal = false;
          this.descriptionLoading = false;
        });
    },
  },

  mounted() {},
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
